import React from 'react';

function Index() {
  return (
    <>
      <h1>Registration Error</h1>
      <p>
        An error occured during the registration process. This could have been caused by one of the
        following issues.
      </p>
      <ul>
        <li>You have already registered using a different provider</li>
        <li>The provied Producer ID and Registration Code do not match</li>
        <li>Your licensing paperwork with Baltimore Life has not been completed</li>
      </ul>
      <p>
        Please reach out to Baltimore Life Agent Relations at (877) 533-2468 for more information.
      </p>
    </>
  );
}

export { Index };
